import PropTypes from 'prop-types';
import React from 'react';
import { getBgColor } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const FilterButton = ({
    filterColour,
    handleFilter,
    isSelected,
    title,
    total,
}) => {

    return (
        <button
            className='relative flex flex-row filter-button whitespace-nowrap'
            data-selected={isSelected}
            onClick={handleFilter}
            type='button'>
            <span className='type-style-4 border rounded-full px-14 py-5 bg-foreground z-10'>
                {title}
            </span>
            <span
                className={'type-style-6 h-full border filter-span rounded-r-full text-center w-[50px] md:w-[55px] flex items-center justify-end'}
                style={{ backgroundColor: getBgColor(filterColour) }}>
                <p className='mr-15'>
                    {total}
                </p>
            </span>
        </button>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    handleFilter: PropTypes.func,
    isSelected: PropTypes.bool,
    filterColour: PropTypes.string,
    title: PropTypes.string,
    total: PropTypes.number,
};

FilterButton.propTypes = propTypes;

export default FilterButton;
